import React, {Component} from 'react';
import defaultOptions from './defaultOptions';
import SelectBox from "../SelectBox";
import ValueTypeSelector from "../ValueTypeSelector";
import {connect} from "react-redux";
import InputWithLabel from "../InputWithLabel";
import MaterialIcon from "../../../MaterialIcon";
import addPropertyFilterRule from "../PropertyFilterRule";

class ItemOrder extends Component {
    constructor(props) {
        super(props);
        this.onTypeSelect = this.onTypeSelect.bind(this);
        this.onPropertySelect = this.onPropertySelect.bind(this);
    }


    onTypeSelect(index, text, types) {
        const xmlType = types.find((type) => type.text === text).xmlType;

        this.props.handlePropertiesChange(index, this.props.selectedOption,
            xmlType);
        if (xmlType === "contextProperty") {
            if (this.props.contextProperties.length > 0) {
                this.props.handlePropertiesChange(index,
                    this.props.selectedValue,
                    this.props.contextProperties[0].name);
            } else {
                this.props.handlePropertiesChange(index,
                    this.props.selectedValue, "");
            }
        } else if (xmlType === "constantValue") {
            this.props.handlePropertiesChange(index, this.props.selectedValue,
                this.props.defaultInputValue);

        } else if (xmlType === "itemProperty") {
            this.props.handlePropertiesChange(index, this.props.selectedValue,
                this.props.itemProperties);
        }
    }

    onPropertySelect(index, property) {
        this.props.handlePropertiesChange(index, this.props.selectedProperty,
            property);

        this.props.handlePropertiesChange(index, this.props.selectedOption,
           "contextProperty");
    }

    render() {
        return (
            <div className="filter-group item-order">
                <div className="filter-group-header">
                    <label className="checkbox-wrapper">Item Order</label>
                </div>
                <div className="filter-group-content">
                    <div className="base-filter-rule">
                        <div className="input-container">
                            <SelectBox
                                handleChangeSelect={(event) => this.props.handleChange(
                                    "order", event.target.value)}
                                selectValue={this.props.sorterOptions["order"]}
                                selectArray={defaultOptions["itemOrders"]}
                            />
                        </div>
                    </div>
                    {(this.props.sorterOptions["order"] === "mespRanking") &&
                        renderMespPropertyFilterRule(this.props)}
                    {this.props.sorterOptions["order"] === "property" &&
                        <div className="dynamic-property-filter">

                            <div className="filter-rule-list">
                                {renderPropertyFilterRule(this.props,
                                    this.onTypeSelect, this.onPropertySelect)}
                            </div>
                            <div className="add-filter-property">
                            <button className="add-button"
                                        onClick={() => addPropertyFilterRule(this.props)}>
                                    <MaterialIcon icon="add_circle"/>Add Input
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
  return {
    contextProperties: state.contextProperties
  }
}

function renderMespPropertyFilterRule(props) {
    return (
        <div>
            <InputWithLabel
                label="Expression:"
                handleChange={(event) => props.handleChange(
                    "mespExpression",
                    event.target.value)}
                value={props.sorterOptions["mespExpression"]}
            />
            <div className="input-container">
                <span className="static-text">Order:</span>
                <SelectBox
                    handleChangeSelect={(event) => this.props.handleChange(
                        "orderAscending",
                        event.target.value)}
                    selectValue={this.props.sorterOptions["orderAscending"]}
                    selectArray={defaultOptions["orderOptions"]}
                />
            </div>
        </div>
    )
}

function renderPropertyFilterRule(props, onTypeSelect, onPropertySelect) {
    const sorterProperties = props.sorterOptions.sorterProperties?  props.sorterOptions.sorterProperties: [props.sorterOptions];
    return(
        sorterProperties.map((value, index) => {
            return (
                <div className="filter-rule sort" key={index}>
                <div className="rule-container sort">
                        <SelectBox
                            handleChangeSelect={(event) => onPropertySelect(index, event.target.value)}
                            selectValue={sorterProperties[index]["property"]}
                            selectArray={defaultOptions["propertyOptions"]}
                        />
                    </div>
                    <div className="rule-container padded right-section sort">
                        <div className="property-input sort">
                            {sorterProperties[index]["property"] === "dynamicProperty" &&
                                <ValueTypeSelector types={props.dynamicTypes}
                                                   selectedType={sorterProperties[index]["propertyType"]}
                                                   onTypeSelect={(text) => onTypeSelect(index,
                                                       text, props.dynamicTypes)}/>
                            }
                            {sorterProperties[index]["property"] === "itemProperty" &&
                                <ValueTypeSelector types={props.itemTypes}
                                                   selectedType={sorterProperties[index]["propertyType"]}
                                                   onTypeSelect={(text) => onTypeSelect(index,
                                                       text, props.itemTypes)}/>
                            }
                            {sorterProperties[index]["propertyType"]=== "constantValue" &&
                                <div className="input-container sort">
                                    <input
                                        onChange={(event) => props.handlePropertiesChange(
                                            index,"propertyValue", event.target.value)}
                                        className="constant-input"
                                        type="text"
                                        value={sorterProperties[index]["propertyValue"]}
                                        placeholder="Enter Value"
                                    />
                                </div>
                            }
                            {sorterProperties[index]["propertyType"] === "contextProperty" &&
                                <div className="input-container sort">
                                    <div className="form-select">
                                        <span className="arrow"><MaterialIcon icon="keyboard_arrow_down" size={24}/></span>
                                        <select value={sorterProperties[index]["propertyValue"]}
                                                onChange={(e) => props.handlePropertiesChange(
                                                    index, "propertyValue", e.target.value)}>
                                            <option value=""> Please select an option</option>
                                            {props.contextProperties && props.contextProperties.map((contextProp) => (
                                                <option key={contextProp.name}>{contextProp.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            }
                            {sorterProperties[index]["propertyType"] === "itemProperty" &&
                                <div className="input-container sort">
                                    <div className="form-select">
                                        <span className="arrow"><MaterialIcon icon="keyboard_arrow_down" size={24}/></span>
                                        <select value={sorterProperties[index]["propertyValue"]}
                                                onChange={(event) => props.handlePropertiesChange(
                                                    index, "propertyValue", event.target.value)}>
                                            <option value=""> Please select an option </option>
                                            {props.itemProperties && props.itemProperties.map((property) => (
                                                <option key={property}>{property}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="input-container sort">
                        <span className="static-text sort">Order:</span>
                        <SelectBox
                            handleChangeSelect={(event) => props.handlePropertiesChange(
                                index,
                                "orderAscending", event.target.value)}
                            selectValue={sorterProperties[index]["orderAscending"]}
                            selectArray={defaultOptions["orderOptions"]}
                        />
                    </div>
                    <div className="input-container sort">
                        <span className="static-text sort">Comparator:</span>
                        <SelectBox
                            handleChangeSelect={(event) => props.handlePropertiesChange(
                                index,
                                "comparator", event.target.value)}
                            selectValue={sorterProperties[index]["comparator"]}
                            selectArray={defaultOptions["comparatorOptions"]}
                        />
                    </div>
                    {sorterProperties.length > 1 &&
                        <button className="remove-filter-rule-button"
                                onClick={() => props.handlePropertiesRemove(
                                    index)}><MaterialIcon icon="close"/></button>}
                </div>
        )}))
}

export default connect(mapStateToProps)(ItemOrder);
